import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=1bde6f95&scoped=true&"
import script from "./Currency.vue?vue&type=script&lang=ts&"
export * from "./Currency.vue?vue&type=script&lang=ts&"
import style0 from "./Currency.vue?vue&type=style&index=0&id=1bde6f95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bde6f95",
  null
  
)

export default component.exports